export default __webpack_public_path__ + "content/media/1.b35339a0.jpg";